// src/app/pages/report-card/report-card.ts

import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { SeoService } from '../../services/seo.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

export interface DelegationMember {
  bioguideId: string;
  name: string;
  party: string;
  chamber: string;
  district: string;
  imageUrl: string;
  url: string;
}

const MICHIGAN_DELEGATION: DelegationMember[] = [
  // ── SENATE ──────────────────────────────────────────────────────────────────
  {
    bioguideId: 'P000595',
    name: 'Gary Peters',
    party: 'Democratic',
    chamber: 'Senate',
    district: 'Senior Senator',
    imageUrl: 'https://www.congress.gov/img/member/p000595_200.jpg',
    url: 'https://www.congress.gov/member/gary-peters/P000595',
  },
  {
    bioguideId: 'S001208',
    name: 'Elissa Slotkin',
    party: 'Democratic',
    chamber: 'Senate',
    district: 'Junior Senator',
    imageUrl: 'https://www.congress.gov/img/member/s001208_200.jpg',
    url: 'https://www.congress.gov/member/elissa-slotkin/S001208',
  },

  // ── HOUSE ───────────────────────────────────────────────────────────────────
  {
    bioguideId: 'B001301',
    name: 'Jack Bergman',
    party: 'Republican',
    chamber: 'House',
    district: 'District 1 - Upper Peninsula',
    imageUrl: 'https://www.congress.gov/img/member/b001301_200.jpg',
    url: 'https://www.congress.gov/member/jack-bergman/B001301',
  },
  {
    bioguideId: 'M001194',
    name: 'John Moolenaar',
    party: 'Republican',
    chamber: 'House',
    district: 'District 2 - West/Central Michigan',
    imageUrl: 'https://www.congress.gov/img/member/m001194_200.jpg',
    url: 'https://www.congress.gov/member/john-moolenaar/M001194',
  },
  {
    bioguideId: 'S001221',
    name: 'Hillary Scholten',
    party: 'Democratic',
    chamber: 'House',
    district: 'District 3 - Grand Rapids',
    imageUrl: 'https://www.congress.gov/img/member/s001221_200.jpg',
    url: 'https://www.congress.gov/member/hillary-scholten/S001221',
  },
  {
    bioguideId: 'H001058',
    name: 'Bill Huizenga',
    party: 'Republican',
    chamber: 'House',
    district: 'District 4 - Kalamazoo/Holland',
    imageUrl: 'https://www.congress.gov/img/member/h001058_200.jpg',
    url: 'https://www.congress.gov/member/bill-huizenga/H001058',
  },
  {
    bioguideId: 'W000798',
    name: 'Tim Walberg',
    party: 'Republican',
    chamber: 'House',
    district: 'District 5 - Lansing/Jackson',
    imageUrl: 'https://www.congress.gov/img/member/w000798_200.jpg',
    url: 'https://www.congress.gov/member/tim-walberg/W000798',
  },
  {
    bioguideId: 'D000624',
    name: 'Debbie Dingell',
    party: 'Democratic',
    chamber: 'House',
    district: 'District 6 - Ann Arbor/Dearborn',
    imageUrl: 'https://www.congress.gov/img/member/d000624_200.jpg',
    url: 'https://www.congress.gov/member/debbie-dingell/D000624',
  },
  {
    bioguideId: 'B001321',
    name: 'Tom Barrett',
    party: 'Republican',
    chamber: 'House',
    district: 'District 7 - Lansing area',
    imageUrl: 'https://www.congress.gov/img/member/b001321_200.jpg',
    url: 'https://www.congress.gov/member/tom-barrett/B001321',
  },
  {
    bioguideId: 'M001237',
    name: 'Kristen McDonald Rivet',
    party: 'Democratic',
    chamber: 'House',
    district: 'District 8 - Flint/Bay City',
    imageUrl: 'https://www.congress.gov/img/member/m001237_200.jpg',
    url: 'https://www.congress.gov/member/kristen-mcdonald-rivet/M001237',
  },
  {
    bioguideId: 'M001136',
    name: 'Lisa McClain',
    party: 'Republican',
    chamber: 'House',
    district: 'District 9 - Macomb/Port Huron',
    imageUrl: 'https://www.congress.gov/img/member/m001136_200.jpg',
    url: 'https://www.congress.gov/member/lisa-mcclain/M001136',
  },
  {
    bioguideId: 'J000307',
    name: 'John James',
    party: 'Republican',
    chamber: 'House',
    district: 'District 10 - Macomb/Oakland',
    imageUrl: 'https://www.congress.gov/img/member/j000307_200.jpg',
    url: 'https://www.congress.gov/member/john-james/J000307',
  },
  {
    bioguideId: 'S001215',
    name: 'Haley Stevens',
    party: 'Democratic',
    chamber: 'House',
    district: 'District 11 - Oakland County',
    imageUrl: 'https://www.congress.gov/img/member/s001215_200.jpg',
    url: 'https://www.congress.gov/member/haley-stevens/S001215',
  },
  {
    bioguideId: 'T000481',
    name: 'Rashida Tlaib',
    party: 'Democratic',
    chamber: 'House',
    district: 'District 12 - Detroit/Dearborn',
    imageUrl: 'https://www.congress.gov/img/member/t000481_200.jpg',
    url: 'https://www.congress.gov/member/rashida-tlaib/T000481',
  },
  {
    bioguideId: 'T000488',
    name: 'Shri Thanedar',
    party: 'Democratic',
    chamber: 'House',
    district: 'District 13 - Detroit',
    imageUrl: 'https://www.congress.gov/img/member/t000488_200.jpg',
    url: 'https://www.congress.gov/member/shri-thanedar/T000488',
  },
];

@Component({
  selector: 'app-report-card',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './report-card.html',
  styleUrls: ['./report-card.css']
})
export class ReportCardComponent implements OnInit {

  senators: DelegationMember[] = [];
  representatives: DelegationMember[] = [];
  isLoading = true;

  private readonly baseUrl =
    'https://www.lydialynnchristensen.com';

  private readonly reportCardPageId =
    `${this.baseUrl}/report-card#report-card`;

  private readonly delegationListId =
    `${this.baseUrl}/report-card#delegation`;

  constructor(
    private cdr: ChangeDetectorRef,
    private seo: SeoService
  ) {}

  ngOnInit(): void {
    this.seo.update(
      'Michigan Delegation Report Card',
      'See how Michigan\'s congressional delegation votes on the issues that matter. Independent tracking by Lydia Christensen\'s campaign.',
      'report-card'
    );

    this.seo.setStructuredData({
      "@context": "https://schema.org",

      "@graph": [
        {
          "@type": "CollectionPage",

          "@id": this.reportCardPageId,

          "url":
            `${this.baseUrl}/report-card`,

          "name":
            "Michigan Delegation Report Card",

          "description":
            "See how Michigan's congressional delegation votes on the issues that matter. Independent tracking by Lydia Christensen's campaign.",

          "isPartOf": {
            "@id": this.seo.websiteId
          },

          "about": {
            "@id": this.seo.lydiaId
          },

          "publisher": {
            "@id": this.seo.campaignId
          },

          "mainEntity": {
            "@id": this.delegationListId
          },

          "inLanguage": "en-US"
        },

        {
          "@type": "ItemList",

          "@id": this.delegationListId,

          "name":
            "Michigan Congressional Delegation",

          "description":
            "Members of Michigan's congressional delegation tracked on the Lydia Christensen campaign's report card.",

          "numberOfItems":
            MICHIGAN_DELEGATION.length,

          "itemListOrder":
            "https://schema.org/ItemListOrderAscending",

          "itemListElement":
            MICHIGAN_DELEGATION.map(
              (member, index) => ({
                "@type": "ListItem",

                "position":
                  index + 1,

                "name":
                  member.name,

                "url":
                  member.url
              })
            )
        }
      ]
    });

    this.senators =
      MICHIGAN_DELEGATION.filter(
        member =>
          member.chamber === 'Senate'
      );

    this.representatives =
      MICHIGAN_DELEGATION.filter(
        member =>
          member.chamber === 'House'
      );

    this.isLoading = false;

    this.cdr.detectChanges();
  }

  onImgError(event: Event): void {
    const img =
      event.target as HTMLImageElement;

    img.style.display = 'none';

    if (img.parentElement) {
      img.parentElement.classList.add(
        'no-photo'
      );
    }
  }
}